export const internalUser = email => {
  const split = email.toLowerCase().split('@')
  if (split.length > 1) {
    const domain = split[1]
    return internalEmailDomains.includes(domain)
  }

  return false
}

const internalEmailDomains = [
  'utcaus.com',
  'utas.utc.com',
  'collins.com',
  'rockwellcollins.com',
  'nm.hsd.utc.com',
  'hs.utc.com',
]

export const profileNameInitials = profileName => {
  if (profileName && profileName.length > 0) {
    const words = profileName.split(/[\s-]+/)
    return words
      .map(word => word.substr(0, 1))
      .filter(letter => letter !== '(')
      .join('')
      .substr(0, 3)
      .toUpperCase()
  }
  return ''
}
